import keys from 'lodash/keys';
import CustomersAllIcon from './icons/customers-all.svg';
import CustomersRegularIcon from './icons/customers-regular.svg';
import CustomersLapsingIcon from './icons/customers-lapsing.svg';
import CustomersProspectiveIcon from './icons/customers-prospective.svg';
import { t } from '../../../infra/i18n';
export var getCustomerGroupsViewConfig = function () { return ({
    all: {
        displayGroupName: t('customers:groups.all_clients'),
        IconComponent: CustomersAllIcon,
    },
    regular: {
        displayGroupName: t('customers:groups.regular_clients'),
        IconComponent: CustomersRegularIcon,
    },
    lapsing: {
        displayGroupName: t('customers:groups.lapsed_clients'),
        IconComponent: CustomersLapsingIcon,
    },
    prospective: {
        displayGroupName: t('customers:groups.prospective_clients'),
        IconComponent: CustomersProspectiveIcon,
    },
}); };
// Static config for non-translated usage
var staticCustomerGroupsViewConfig = {
    all: {
        displayGroupName: 'All clients',
        IconComponent: CustomersAllIcon,
    },
    regular: {
        displayGroupName: 'Regular clients',
        IconComponent: CustomersRegularIcon,
    },
    lapsing: {
        displayGroupName: 'Lapsed clients',
        IconComponent: CustomersLapsingIcon,
    },
    prospective: {
        displayGroupName: 'Prospective clients',
        IconComponent: CustomersProspectiveIcon,
    },
};
export var GROUPS_TO_SHOW = keys(staticCustomerGroupsViewConfig);
